import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  position: relative;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors['white']};
  padding: 20px;
  gap: 10px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    padding: 16px;
  }

  .ttTitle {
    color: ${(props) => props.theme.colors['terra-cotta']};
    font-size: 16px;
  }

  .boxArticles {
    display: grid;
    gap: 30px;
    margin-left: 40px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-left: 0;
    }
  }

  .articlesContent {
    display: grid;
    gap: 20px;
  }

  .userArticlesTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 18px;
    color: ${(props) => props.theme.colors['terra-cotta']};
    text-transform: uppercase;
  }

  .boxItem {
    position: relative;
  }

  .header {
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    .compactDisplay {
      display: flex;
      gap: 16px;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-size: 12px;
      line-height: 1.71;
      color: #2b3d54;
    }
  }

  .offsetSmall {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin: 15px auto;
    }
  }

  .header-link {
    width: 200px;
  }

  .tooltip {
    visibility: hidden;
    width: 230px;
    height: auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 3px 2px 8px 2px rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(173, 181, 189, 0.2);
    position: absolute;
    z-index: 1;
    bottom: 0px;
    left: 110px;

    ::after {
      content: '';
      width: 10px;
      height: 10px;
      background-color: white;
      border-bottom: solid 1px #e5eef5;
      border-right: solid 1px #e5eef5;
      position: absolute;
      transform: rotate(135deg);
      bottom: 7px;
      left: -6px;
    }
  }

  .tooltip-container {
    position: relative;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
      margin-top: 10px;
    }
  }

  .actions-button {
    border-radius: 24px;
    width: 96px;
    height: 32px;
    font-weight: 400;
    background-color: rgb(226 93 52);
    padding: 0 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
      padding: 0;
    }
  }

  .actions-button.disabled {
    background-color: rgb(226 93 52 / 50%);
  }

  .actions-button.disabled div {
    background-color: transparent;
  }

  .actions-button.disabled .ant-space,
  .actions-button.disabled .ant-space-item {
    background-color: transparent;
  }

  .action-button-label {
    font-size: 16px;
    align-items: center;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      font-size: 16px;
    }
  }

  .action-button-icon {
    font-size: 20px;
  }

  .rightComponentScore {
    margin-left: auto;
  }

  .checkboxItem {
    position: absolute;
    left: -35px;
    top: 40%;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      top: 15px;
      left: 15px;
    }
  }

  .checkbox-label {
    color: #2b3d54;
    font-size: 12px;
    padding-right: 10px;
    opacity: 0.5;
  }

  .selectAll {
    text-decoration: underline;
    cursor: pointer;
  }

  .exportContainer {
    margin-left: auto;
  }
`;

export default Container;
